import httpClient from '../httpClient';

const post = async (data) => {
  return await httpClient.post(`/term_legal_validation_training/`, data);
};

const getAllByValidation = async (validation_id) => {
  return await httpClient.get(
    `/term_legal_validation_training/${validation_id}`,
  );
};

export { post, getAllByValidation };
